import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { useErrorToast } from '@/core/errors/useErrorToast';
import { productsService, type CreateProductData, type UpdateProductData } from '../api/products.service';

export function useSaveProductMutation() {
  const client = useQueryClient();
  const onError = useErrorToast();
  return useMutation({
    mutationFn: (input: { id: string; data: UpdateProductData } | { id?: undefined; data: CreateProductData }) => input.id
      ? productsService.update(input.id, input.data)
      : productsService.create(input.data as CreateProductData),
    onSuccess: () => { void client.invalidateQueries({ queryKey: queryKeys.products.all }); toast.success('Produto salvo com sucesso.'); },
    onError: (error) => onError(error, 'Erro ao salvar produto'),
  });
}
